import { createReducer } from "@reduxjs/toolkit";
import { studentRetrieveAllTrainingItems } from "./retrieve-training-items";
import type { TrainingItemVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<TrainingItemVM[]> = { fetching: "pending", data: [] };

export const studentRetrieveTrainingItemsReducer = createReducer<RetrievalState<TrainingItemVM[]>>(initialState, builder => {
  builder.addCase(studentRetrieveAllTrainingItems.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrieveAllTrainingItems.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrieveAllTrainingItems.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
